import { userInfoState, shopListState, siteListState } from 'store/atom/user-state-atom'
import { useSetRecoilState } from 'recoil'
import { APP_INFO_CONST } from 'constants/app_info_const'
import { useCookies } from 'react-cookie'
import { axiosInstance } from 'api/apiConfig'
import { decrypt, encrypt } from 'utils/crypto-util'

/**
 * @description 공통 Modal용 Hook
 * @author 이종술
 * @since 2023-02-05
 * 업무 : Hook > 공통 > Modal Hook
 */

export default function useCommon() {
  const setUserInfo = useSetRecoilState(userInfoState)
  const setShopList = useSetRecoilState(shopListState)
  const setSiteList = useSetRecoilState(siteListState)
  
  const removeUserInfo = () => {
    localStorage.removeItem(APP_INFO_CONST.IS_LOGIN)
    localStorage.removeItem(APP_INFO_CONST.TOKEN_KEY)
    localStorage.removeItem(APP_INFO_CONST.REFRESH_TOKEN_KEY)
    setUserInfo({
      userId: '',
      userName: '',
    })
    setShopList(() => [])
    setSiteList(() => [])
    localStorage.removeItem(APP_INFO_CONST.AUTO_LOGIN_KEY)
  }

  const refreshToken = async (callback=()=>{}) => {
    const result = await axiosInstance
    .post(
      '/user/refreshToken',
      {},
      {
        headers: {
          refreshToken: decrypt(localStorage.getItem(APP_INFO_CONST.REFRESH_TOKEN_KEY)),
        },
      },
    )
    
    localStorage.setItem(APP_INFO_CONST.TOKEN_KEY, encrypt(result.data.accessToken))
    localStorage.setItem(APP_INFO_CONST.REFRESH_TOKEN_KEY, encrypt(result.data.refreshToken))
    callback()

    // .then((result) => {
    //   localStorage.setItem(APP_INFO_CONST.TOKEN_KEY, encrypt(result.data.accessToken))
    //   localStorage.setItem(APP_INFO_CONST.REFRESH_TOKEN_KEY, encrypt(result.data.refreshToken))
    //   callback()
    // })
  }
  
  return {
    removeUserInfo,
    refreshToken
  }
}
